import React from "react";
import QuickBook from "./components/QuickBook";
import About from "./components/About";
import Services from "./components/Services";
import ChooseParsal from "./components/ChooseParsal";
import Hero from "./components/Hero";
import Navbar from "../../components/Navbar";
import { parsal_img } from "../../assets/mediaCall";
import Work from "./components/Work";
import Footer from "../../components/Footer";
import GlobalService from "./components/GlobalService";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/Faq";
import AppDownloadSection from "./components/AppDownload";

const Home = () => {
  //  h-[100vh] mdg:h-[90vh] sm:h-[100vh]
  return (
    <>
      <div
        className="bg-cover bg-center"
        style={{
          backgroundImage: `url(${parsal_img.hero_bg})`,
          backgroundColor: "#F3F3F6",
        }}
      >
        <Navbar />
        <Hero />
      </div>
      <div className="relative w-full">
        <QuickBook />
      </div>
      {/* <QuickBook /> */}
      <About />
      <Services />
      <ChooseParsal />
      <Work />
      <GlobalService />
      <AppDownloadSection />
      <Testimonials />
      <FAQ />
      <Footer />
    </>
  );
};

export default Home;
